<template>
  <div class="procure-mes-input card flex-center">
    <el-input
      v-model.trim="chatMes"
      maxlength="200"
      placeholder="请输入内容"
      @keyup.enter.native="sendMes"
    />
    <el-button
      :type="disabled ? 'info' : 'primary'"
      :disabled="disabled"
      @click="sendMes"
    >发送</el-button>
  </div>
</template>

<script>
export default {
  name: 'ProcureMesInput',

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    sendMesFun: {
      type: Function,
      require: true
    }
  },

  data() {
    return {
      chatMes: ''
    }
  },

  methods: {
    sendMes() {
      if (!this.chatMes) {
        this.$message.warning('请输入发送的内容')
        return
      }

      const chatMes = this.chatMes
      this.chatMes = ''
      this.sendMesFun(chatMes)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.procure-mes-input {
  height: 60px;
  margin-top: 10px;
  padding: 0 pixel-to-rem($n: 20);

  ::v-deep .el-input {
    flex: 1;
  }

  ::v-deep .el-button {
    margin-left: pixel-to-rem($n: 20);
  }
}
</style>
